var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-dialog', _vm._b({ attrs: { "visible": _vm.dialogVisible }, on: { "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      } } }, 'el-dialog', _vm.dialogAttrs, false), [_c('authorization-form', { ref: "authorizationFormRef", attrs: { "action": _vm.action, "formItemInfo": _vm.formItemInfo }, on: { "cancel": _vm.closeDialog, "save-form": _vm.updateAuthorizationList } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };